var map = {
	"./camp.png": 2045,
	"./circle.svg": 1804,
	"./creative.png": 2046,
	"./frontend.png": 2047,
	"./gamedesign.png": 2048,
	"./graphicdesign.png": 2049,
	"./junior.png": 2050,
	"./math-3-4.png": 2051,
	"./math-5-6.png": 2052,
	"./pc.png": 2053,
	"./pytpro-nosnake.png": 2054,
	"./pytpro.png": 2055,
	"./pytstart-nosnake.png": 2056,
	"./pytstart.png": 2057,
	"./quadrangle.svg": 1802,
	"./unity.png": 2058,
	"./videocontent.png": 2059,
	"./websites.png": 2060
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1803;